import React, {useEffect, useRef, useState} from 'react'
import styles from './EventNameTagsPage.module.css';
import {useParams} from "react-router";
import {useAutoEvent} from "../../queries/useAutoEvent";
import {Editor, EditorTools} from "@progress/kendo-react-editor";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import {AppBar} from "@mui/material";

interface Params {
  eventid: string
    guides: any
}

const richTextTools = [
    [EditorTools.Bold, EditorTools.Italic, EditorTools.Underline, EditorTools.Strikethrough],
    // [EditorTools.Subscript, EditorTools.Superscript],
    EditorTools.ForeColor,
    EditorTools.BackColor,
    [EditorTools.CleanFormatting],
    [EditorTools.AlignLeft, EditorTools.AlignCenter, EditorTools.AlignRight, EditorTools.AlignJustify],
    [EditorTools.Indent, EditorTools.Outdent],
    [EditorTools.OrderedList, EditorTools.UnorderedList],
    EditorTools.FontSize,
    EditorTools.FontName,
    EditorTools.FormatBlock,
    [EditorTools.SelectAll],
    [EditorTools.Undo, EditorTools.Redo],
    [EditorTools.Link, EditorTools.Unlink, EditorTools.InsertImage, EditorTools.ViewHtml],
    [EditorTools.InsertTable, EditorTools.InsertFile],
    // [EditorTools.Pdf, EditorTools.Print],
    [EditorTools.AddRowBefore, EditorTools.AddRowAfter, EditorTools.AddColumnBefore, EditorTools.AddColumnAfter],
    [EditorTools.DeleteRow, EditorTools.DeleteColumn, EditorTools.DeleteTable],
    [EditorTools.MergeCells, EditorTools.SplitCell],
]

const EventNameTagsPage = () => {
    const { eventid, guides } = useParams<Params>()
    const [editorValue, setEditorValue] = useState('')
    const horizonalGuidesRef = useRef();
    const verticalGuidesRef = useRef();
    console.log(eventid)
    useAutoEvent(eventid)
    const [tabSel, setTabSel] = React.useState<number>(0)

    useEffect(() => {
        setEditorValue('Scott')
    }, [])

    const handleTabChange = (event: React.SyntheticEvent, newValue: number) => {
        setTabSel(newValue)
    }

    return (
      <div className={styles.root}>
        <h1>Event Name Tags and Labels</h1>

          <AppBar position="static" color="default">
              <Tabs
                  value={tabSel}
                  onChange={handleTabChange}
                  indicatorColor="primary"
                  textColor="primary"
                  variant="scrollable"
                  scrollButtons="auto"
                  aria-label="scrollable auto tabs example"
              >
                  <Tab value={0} label={'Listing'}></Tab>
                  <Tab value={1} label={'Design'}></Tab>
                  <Tab value={3} label={'Names'}></Tab>
                  <Tab value={4} label={'Review & Print'}></Tab>
              </Tabs>
              {tabSel === 1 && (
                  <Editor
                      tools={richTextTools}
                      contentStyle={{ width: 288, height: 216, border: '1px #000 solid', overflow: 'hidden' }}
                      value={editorValue}
                      onChange={(eventState) => {
                          setEditorValue(eventState.html)
                      }}
                  />
              )}
          </AppBar>
          {/*<Guides*/}
          {/*    ref={horizonalGuidesRef}*/}
          {/*    rulerStyle={{*/}
          {/*        left: "30px",*/}
          {/*        width: "calc(100% - 30px)",*/}
          {/*        height: "100%"*/}
          {/*    }}*/}
          {/*    displayDragPos={true}*/}
          {/*    displayGuidePos={true}*/}
          {/*    useResizeObserver={true}*/}
          {/*    // ref={e => {*/}
          {/*    //     this.guides = e;*/}
          {/*    // }}*/}
          {/*    type="horizontal"*/}
          {/*/>*/}




      </div>
    )
}

export default EventNameTagsPage
